unit View.Promocoes.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  WEBLib.Lists, WEBLib.Grids, Grid.Plugins, System.StrUtils, UConstantes,
  UHelperServer, UUtils, UFrameAssociacaoProdutos, Vcl.Forms, WEBLib.WebCtrls,
  UWeb.Enum, System.Generics.Collections;

type
  TFViewPromocoesEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_nome: TLabel;
    edaliado_nome: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbfuncionario_nome: TLabel;
    edfuncionario_nome: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbdata_inicio: TLabel;
    eddata_inicio: TDBEdit;
    lbdata_fim: TLabel;
    eddata_fim: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientPromocoesGet: TXDataWebClient;
    PromocoesDataset: TXDataWebDataSet;
    PromocoesDatasetid: TIntegerField;
    PromocoesDatasetaliado_id: TIntegerField;
    PromocoesDatasetdata_base_id: TIntegerField;
    PromocoesDatasetfuncionario_id: TIntegerField;
    PromocoesDatasetnome: TStringField;
    PromocoesDatasetdata_inicio: TDateTimeField;
    PromocoesDatasetdata_fim: TDateTimeField;
    PromocoesDatasetstatus: TIntegerField;
    PromocoesDatasetcodigo_interno: TIntegerField;
    PromocoesDatasetexcluido: TBooleanField;
    PromocoesDatasetinclusao: TDateTimeField;
    PromocoesDatasetalteracao: TDateTimeField;
    PromocoesDatasetexclusao: TDateTimeField;
    PromocoesDatasetaliadoNome_Fantasia: TXDataWebDatasetField;
    PromocoesDatasetfuncionarionome: TXDataWebDatasetField;
    cbbexcluido: TDBCheckBox;
    lbPaginationInfo: TLabel;
    WebDBTableControl1: TDBTableControl;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lcPaginator: TListControl;
    Promocoes_ItensDataset: TXDataWebDataSet;
    Promocoes_ItensDatasetid: TIntegerField;
    Promocoes_ItensDatasetproduto_id: TIntegerField;
    Promocoes_ItensDatasetpreco_promocional: TFloatField;
    Promocoes_ItensDatasetexcluido: TBooleanField;
    Promocoes_ItensDatasetinclusao: TDateTimeField;
    Promocoes_ItensDatasetalteracao: TDateTimeField;
    Promocoes_ItensDatasetexclusao: TDateTimeField;
    WebDataSource: TDataSource;
    pnlDadosPromocao: TPanel;
    pnlItensPromocao: TPanel;
    btnItensTab: TButton;
    tmrConsulta: TTimer;
    Promocoes_ItensDatasetprodpreco_venda: TFloatField;
    Promocoes_ItensDatasetprodnome: TXDataWebDatasetField;
    Promocoes_ItensDatasetprodcodigo_barras: TXDataWebDatasetField;
    Promocoes_ItensDatasetprodcodigo_interno: TXDataWebDatasetField;
    Promocoes_ItensDatasetprodassociacaofsprodimagem: TXDataWebDatasetField;
    Promocoes_ItensDatasetprodassociacaostatus: TXDataWebDatasetField;
    btnMarcarDesmarcarTodos: TButton;
    btnGerenciarAssociacao: TButton;
    Promocoes_ItensDatasetproddbassociar_produtos: TBooleanField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientPromocoesGetLoad(Response: TXDataClientResponse);
    procedure PromocoesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnItensTabClick(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure PromocoesDatasetstatusGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure frmFrameAssociacaoProdutosXDataWebClientAssociacaoLoad(
      Response: TXDataClientResponse);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
    procedure btnMarcarDesmarcarTodosClick(Sender: TObject);
    procedure btnGerenciarAssociacaoClick(Sender: TObject);
    procedure Promocoes_ItensDatasetAfterOpen(DataSet: TDataSet);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginItens : TGridPlugin;
    FDicionarioAssociacao : TDictionary<Integer, string>;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure AtualizarTextoBotaoGerenciarAssociacao;
    procedure MarcarDesmarcarTodos;
    function MarcarTodosProdutos : Boolean;
    procedure AtualizarNomeTagMarcarDesmarcarTodos(pMarcar : Boolean);
    procedure ChamarTelaProdutos;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewPromocoesEdit: TFViewPromocoesEdit;

implementation

uses
  ConnectionModule,
  View.Main;

{$R *.dfm}

{ TFViewPromocoesEdit }

procedure TFViewPromocoesEdit.btnGerenciarAssociacaoClick(Sender: TObject);
begin
  if FDicionarioAssociacao.Count = 0 then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum produto selecionado!')
  else
    ChamarTelaProdutos;
end;

procedure TFViewPromocoesEdit.btnItensTabClick(Sender: TObject);
begin
  if not Assigned(FGridPluginItens) then
  begin
    FGridPluginItens := TGridPlugin.Create(WebDBTableControl1, Promocoes_ItensDataset,
      lcPaginator, lbPaginationInfo);

    FGridPluginItens.FDatasetPlugin.FFilterPadrao := 'promocao_id eq ' + edid.Text;
    FGridPluginItens.SetPageSize(StrToInt(cbPageSize.Text));
    FGridPluginItens.SetFilterText(edSearch.Text);
    FGridPluginItens.Load;
  end;
end;

procedure TFViewPromocoesEdit.btnMarcarDesmarcarTodosClick(Sender: TObject);
begin
  MarcarDesmarcarTodos;
end;

procedure TFViewPromocoesEdit.cbPageSizeChange(Sender: TObject);
begin
  FGridPluginItens.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewPromocoesEdit.ChamarTelaProdutos;
var
  lPair: TPair<Integer, string>;
  lFilter : string;
begin
  TUtils.ChamarDivLoading;
  try
    lFilter := '(';

    for lPair in FDicionarioAssociacao do
    begin
      lFilter := lFilter + '(id eq '+lPair.Key.ToString + ') or '
    end;

    SetLength(lFilter, Length(lFilter) - 4);
    lFilter := lFilter + ')';
  finally
    if Assigned(FDicionarioAssociacao) then
      FreeAndNil(FDicionarioAssociacao);

    THelperServer.FQueryProdutos := lFilter;
    FViewMain.produtos.OnClick(nil);
  end;
end;

class function TFViewPromocoesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewPromocoesEdit.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginItens.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewPromocoesEdit.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewPromocoesEdit.frmFrameAssociacaoProdutosXDataWebClientAssociacaoLoad(
  Response: TXDataClientResponse);
begin
  if Response.RequestId <> 'null' then
    TUtils.CloseModal(Response.RequestId);
    
  TUtils.CloseModal('modal_detalhes_associacao');
  FGridPluginItens.Load;  
end;

procedure TFViewPromocoesEdit.InsertEntity;
begin
  PromocoesDataset.Close;
  PromocoesDataset.SetJsonData('{}');
  PromocoesDataset.Open;
  PromocoesDataset.Insert;
end;

class function TFViewPromocoesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPromocoesEdit(AForm).FInserting := AInserting;
    TFViewPromocoesEdit(AForm).FId := AId;
    TFViewPromocoesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewPromocoesEdit(AForm).InsertEntity
    else
      TFViewPromocoesEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewPromocoesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewPromocoesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    PromocoesDataset.Connection.Model.DefaultSchema.FindEntityType(
      PromocoesDataset.EntitySetName
    )
  );
  XDataClientPromocoesGet.Get(PromocoesDataset.EntitySetName, QueryString, FId);
end;


procedure TFViewPromocoesEdit.XDataClientPromocoesGetLoad(Response: TXDataClientResponse);
begin
  PromocoesDataset.Close;
  PromocoesDataset.SetJsonData(Response.Result);
  PromocoesDataset.Open;
end;

procedure TFViewPromocoesEdit.PromocoesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewPromocoesEdit.PromocoesDatasetstatusGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  case Sender.AsInteger of
    1 : Text := 'Iniciada';
    2 : Text := 'Agendada';
    3 : Text := 'Em criação';
    4 : Text := 'Encerrada';
  end;
end;

procedure TFViewPromocoesEdit.Promocoes_ItensDatasetAfterOpen(
  DataSet: TDataSet);
begin
  AtualizarNomeTagMarcarDesmarcarTodos(True);
end;

procedure TFViewPromocoesEdit.tmrConsultaTimer(Sender: TObject);
begin
  FGridPluginItens.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewPromocoesEdit.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordBase64: string;
  lProdutoId : Integer;
  lBancoAssociacao : Boolean;

  procedure CheckBoxClick(Sender: TObject);
  var
    lCheckBoxSelecionado: TCheckBox;
  begin
    lCheckBoxSelecionado := TCheckBox(Sender);

    if lCheckBoxSelecionado.Checked then
    begin
      if FDicionarioAssociacao.ContainsKey(lProdutoId) then
        Exit;

      FDicionarioAssociacao.Add(lProdutoId, '');
    end
    else
    begin
      if FDicionarioAssociacao.ContainsKey(lProdutoId) then
        FDicionarioAssociacao.Remove(lProdutoId);
    end;

    AtualizarTextoBotaoGerenciarAssociacao;
  end;
var
  lImagem : TImageControl;
  lCheckBox : TCheckBox;
begin
  if ARow = 0 then
    Exit;

  lProdutoId := Promocoes_ItensDataset.FieldByName('produto_id').AsInteger;
  lBancoAssociacao := Promocoes_ItensDataset.FieldByName('prod.db.associar_produtos').AsBoolean;

  if WebDBTableControl1.Columns[ACol].Title = 'Imagem' then
  begin
    RecordBase64 := Promocoes_ItensDataset.FieldByName('prod.associacao.fsprod.imagem').AsString;

    lImagem := TImageControl.Create(nil);
    lImagem.ParentElement := AElement.element;
    lImagem.Width := 100;
    lImagem.Height := 100;
    lImagem.AutoSize := False;

    if (RecordBase64 = '') or (RecordBase64.ToUpper = 'NULL') then
      lImagem.url := 'assets/img/produto_sem_imagem.webp'
    else
      lImagem.url := RecordBase64;
  end
  else if WebDBTableControl1.Columns[ACol].Title = 'Selecionar' then
  begin
    lCheckBox := TCheckBox.Create(nil);
    lCheckBox.ParentElement := AElement.element;
    lCheckBox.WidthStyle := TSizeStyle.ssAuto;
    lCheckBox.HeightStyle := TSizeStyle.ssAuto;
    lCheckBox.OnClick := @CheckBoxClick;
    lCheckBox.Checked := FDicionarioAssociacao.ContainsKey(lProdutoId);
    lCheckBox.Enabled := lBancoAssociacao;
    lCheckBox.ElementHandle.setAttribute('data-test', 'cbx_selecionar_produto');

    if not lBancoAssociacao then
    begin
      lCheckBox.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      lCheckBox.ElementHandle.setAttribute('title', 'Produto pertence a uma banco não associado!');
    end;
  end;
end;

procedure TFViewPromocoesEdit.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['prod.nome',
      'prod.preco_venda', 'preco_promocional', 'prod.codigo_barras']) of
      0, 3: AClassName := 'text-left';
      1, 2: AClassName := 'text-end';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewPromocoesEdit.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'prod.preco_venda',
      'prod.associacao.status']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1: AValue := '<s>' + AValue + '</s>';
      2: AValue := THelperServer.GetStatusAssociacaoProdutoRounded(AValue);
      else
      begin
        if UpperCase(AValue) = 'NULL' then
          AValue := '';
      end;
    end;
  end;
end;

procedure TFViewPromocoesEdit.WebFormCloseQuery(Sender: TObject;
  var CanClose: Boolean);
begin
  if CanClose then
  begin
    if Assigned(FDicionarioAssociacao) then
      FreeAndNil(FDicionarioAssociacao);
  end;
end;

procedure TFViewPromocoesEdit.WebFormCreate(Sender: TObject);
begin
  FDicionarioAssociacao := TDictionary<Integer, string>.Create;
end;

procedure TFViewPromocoesEdit.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao('promocoes_itens', TTipoPermissao.VISUALIZAR) then
  begin
    TUtils.RemoverElementoPorId(btnItensTab.ElementID);
    TUtils.RemoverElementoPorId('line-itens');
  end;
end;

procedure TFViewPromocoesEdit.AtualizarNomeTagMarcarDesmarcarTodos(
  pMarcar: Boolean);
var
  lCaption : string;
begin
  if pMarcar then
  begin
    lCaption := 'Marcar Todos';
    btnMarcarDesmarcarTodos.Tag := 0;
  end
  else
  begin
    lCaption := 'Desmarcar Todos';
    btnMarcarDesmarcarTodos.Tag := 1;
  end;

  asm
    $('#lblTextoMarcarDesmarcarTodos').text(lCaption);
  end;
end;

procedure TFViewPromocoesEdit.AtualizarTextoBotaoGerenciarAssociacao;
var
  lCaption : string;
begin
  lCaption := 'Associar ('+FDicionarioAssociacao.Count.ToString+') produto(s)';

  asm
    $('#lblTextoAssociacao').text(lCaption);
  end;
end;

procedure TFViewPromocoesEdit.MarcarDesmarcarTodos;
var
  lCaption : string;
begin
  if btnMarcarDesmarcarTodos.Tag = 0 then
  begin
    if MarcarTodosProdutos then
    begin
      lCaption := 'Desmarcar Todos';
      btnMarcarDesmarcarTodos.Tag := 1;
    end
    else
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não foi possível marcar os produtos!' +
        sLineBreak + 'Produtos pertencem a uma banco não associado!');

      Exit;
    end;
  end
  else
  begin
    FDicionarioAssociacao.Clear;
    AtualizarTextoBotaoGerenciarAssociacao;
    FGridPluginItens.Load;

    lCaption := 'Marcar Todos';
    btnMarcarDesmarcarTodos.Tag := 0;
  end;

  asm
    $('#lblTextoMarcarDesmarcarTodos').text(lCaption);
  end;
end;

function TFViewPromocoesEdit.MarcarTodosProdutos : Boolean;
var
  lPodeMarcar : Boolean;
  lTotalMarcados : Integer;
begin
  Result := False;
  lTotalMarcados := 0;

  Promocoes_ItensDataset.DisableControls;
  Promocoes_ItensDataset.First;

  try
    while not Promocoes_ItensDataset.Eof do
    begin
      lPodeMarcar := Promocoes_ItensDataset.FieldByName('prod.db.associar_produtos').AsBoolean
       and not FDicionarioAssociacao.ContainsKey(Promocoes_ItensDataset.FieldByName('produto_id').AsInteger);

      if Promocoes_ItensDataset.FieldByName('prod.db.associar_produtos').AsBoolean then
        Inc(lTotalMarcados);

      if lPodeMarcar then
        FDicionarioAssociacao.Add(Promocoes_ItensDataset.FieldByName('produto_id').AsInteger, '');

      Promocoes_ItensDataset.Next;
    end;

    Result := lTotalMarcados > 0;
  finally
    Promocoes_ItensDataset.EnableControls;
    AtualizarTextoBotaoGerenciarAssociacao;
  end;
end;

procedure TFViewPromocoesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewPromocoesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.promocoes.form.lbid');
  lbaliado_nome := TLabel.Create('view.promocoes.form.lbaliado_nome');
  lbdata_base_id := TLabel.Create('view.promocoes.form.lbdata_base_id');
  lbfuncionario_nome := TLabel.Create('view.promocoes.form.lbfuncionario_nome');
  lbnome := TLabel.Create('view.promocoes.form.lbnome');
  lbdata_inicio := TLabel.Create('view.promocoes.form.lbdata_inicio');
  lbdata_fim := TLabel.Create('view.promocoes.form.lbdata_fim');
  lbstatus := TLabel.Create('view.promocoes.form.lbstatus');
  lbcodigo_interno := TLabel.Create('view.promocoes.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.promocoes.form.lbexcluido');
  lbinclusao := TLabel.Create('view.promocoes.form.lbinclusao');
  lbalteracao := TLabel.Create('view.promocoes.form.lbalteracao');
  lbexclusao := TLabel.Create('view.promocoes.form.lbexclusao');
  lbPaginationInfo := TLabel.Create('view.promocoes_itens.list.pagination.info');
  btCancel := TButton.Create('view.promocoes.form.btBack');
  edid := TDBEdit.Create('view.promocoes.form.edid');
  edaliado_nome := TDBEdit.Create('view.promocoes.form.edaliado_nome');
  eddata_base_id := TDBEdit.Create('view.promocoes.form.eddata_base_id');
  edfuncionario_nome := TDBEdit.Create('view.promocoes.form.edfuncionario_nome');
  ednome := TDBEdit.Create('view.promocoes.form.ednome');
  eddata_inicio := TDBEdit.Create('view.promocoes.form.eddata_inicio');
  eddata_fim := TDBEdit.Create('view.promocoes.form.eddata_fim');
  edstatus := TDBEdit.Create('view.promocoes.form.edstatus');
  edcodigo_interno := TDBEdit.Create('view.promocoes.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.promocoes.form.edinclusao');
  edalteracao := TDBEdit.Create('view.promocoes.form.edalteracao');
  edexclusao := TDBEdit.Create('view.promocoes.form.edexclusao');
  cbbexcluido := TDBCheckBox.Create('view.promocoes.form.cbbexcluido');
  WebDBTableControl1 := TDBTableControl.Create('view.promocoes_itens.list.table');
  cbPageSize := TComboBox.Create('view.promocoes_itens.list.cbPageSize');
  edSearch := TEdit.Create('view.promocoes_itens.list.search');
  lcPaginator := TListControl.Create('view.promocoes_itens.list.pagination');
  pnlDadosPromocao := TPanel.Create(Self);
  pnlItensPromocao := TPanel.Create(Self);
  btnItensTab := TButton.Create('line-itens-tab');
  btnMarcarDesmarcarTodos := TButton.Create('btnMarcarDesmarcarTodos');
  btnGerenciarAssociacao := TButton.Create('btnGerenciarAssociacao');
  DataSource := TDataSource.Create(Self);
  PromocoesDataset := TXDataWebDataSet.Create(Self);
  PromocoesDatasetid := TIntegerField.Create(Self);
  PromocoesDatasetaliado_id := TIntegerField.Create(Self);
  PromocoesDatasetdata_base_id := TIntegerField.Create(Self);
  PromocoesDatasetfuncionario_id := TIntegerField.Create(Self);
  PromocoesDatasetnome := TStringField.Create(Self);
  PromocoesDatasetdata_inicio := TDateTimeField.Create(Self);
  PromocoesDatasetdata_fim := TDateTimeField.Create(Self);
  PromocoesDatasetstatus := TIntegerField.Create(Self);
  PromocoesDatasetcodigo_interno := TIntegerField.Create(Self);
  PromocoesDatasetexcluido := TBooleanField.Create(Self);
  PromocoesDatasetinclusao := TDateTimeField.Create(Self);
  PromocoesDatasetalteracao := TDateTimeField.Create(Self);
  PromocoesDatasetexclusao := TDateTimeField.Create(Self);
  PromocoesDatasetaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  PromocoesDatasetfuncionarionome := TXDataWebDatasetField.Create(Self);
  XDataClientPromocoesGet := TXDataWebClient.Create(Self);
  Promocoes_ItensDataset := TXDataWebDataSet.Create(Self);
  Promocoes_ItensDatasetid := TIntegerField.Create(Self);
  Promocoes_ItensDatasetproduto_id := TIntegerField.Create(Self);
  Promocoes_ItensDatasetpreco_promocional := TFloatField.Create(Self);
  Promocoes_ItensDatasetexcluido := TBooleanField.Create(Self);
  Promocoes_ItensDatasetinclusao := TDateTimeField.Create(Self);
  Promocoes_ItensDatasetalteracao := TDateTimeField.Create(Self);
  Promocoes_ItensDatasetexclusao := TDateTimeField.Create(Self);
  Promocoes_ItensDatasetprodpreco_venda := TFloatField.Create(Self);
  Promocoes_ItensDatasetprodnome := TXDataWebDatasetField.Create(Self);
  Promocoes_ItensDatasetprodcodigo_barras := TXDataWebDatasetField.Create(Self);
  Promocoes_ItensDatasetprodcodigo_interno := TXDataWebDatasetField.Create(Self);
  Promocoes_ItensDatasetprodassociacaofsprodimagem := TXDataWebDatasetField.Create(Self);
  Promocoes_ItensDatasetprodassociacaostatus := TXDataWebDatasetField.Create(Self);
  Promocoes_ItensDatasetproddbassociar_produtos := TBooleanField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbaliado_nome.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  lbfuncionario_nome.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbdata_inicio.BeforeLoadDFMValues;
  lbdata_fim.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbPaginationInfo.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edaliado_nome.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  edfuncionario_nome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  eddata_inicio.BeforeLoadDFMValues;
  eddata_fim.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbbexcluido.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  pnlDadosPromocao.BeforeLoadDFMValues;
  pnlItensPromocao.BeforeLoadDFMValues;
  btnItensTab.BeforeLoadDFMValues;
  btnMarcarDesmarcarTodos.BeforeLoadDFMValues;
  btnGerenciarAssociacao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  PromocoesDataset.BeforeLoadDFMValues;
  PromocoesDatasetid.BeforeLoadDFMValues;
  PromocoesDatasetaliado_id.BeforeLoadDFMValues;
  PromocoesDatasetdata_base_id.BeforeLoadDFMValues;
  PromocoesDatasetfuncionario_id.BeforeLoadDFMValues;
  PromocoesDatasetnome.BeforeLoadDFMValues;
  PromocoesDatasetdata_inicio.BeforeLoadDFMValues;
  PromocoesDatasetdata_fim.BeforeLoadDFMValues;
  PromocoesDatasetstatus.BeforeLoadDFMValues;
  PromocoesDatasetcodigo_interno.BeforeLoadDFMValues;
  PromocoesDatasetexcluido.BeforeLoadDFMValues;
  PromocoesDatasetinclusao.BeforeLoadDFMValues;
  PromocoesDatasetalteracao.BeforeLoadDFMValues;
  PromocoesDatasetexclusao.BeforeLoadDFMValues;
  PromocoesDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  PromocoesDatasetfuncionarionome.BeforeLoadDFMValues;
  XDataClientPromocoesGet.BeforeLoadDFMValues;
  Promocoes_ItensDataset.BeforeLoadDFMValues;
  Promocoes_ItensDatasetid.BeforeLoadDFMValues;
  Promocoes_ItensDatasetproduto_id.BeforeLoadDFMValues;
  Promocoes_ItensDatasetpreco_promocional.BeforeLoadDFMValues;
  Promocoes_ItensDatasetexcluido.BeforeLoadDFMValues;
  Promocoes_ItensDatasetinclusao.BeforeLoadDFMValues;
  Promocoes_ItensDatasetalteracao.BeforeLoadDFMValues;
  Promocoes_ItensDatasetexclusao.BeforeLoadDFMValues;
  Promocoes_ItensDatasetprodpreco_venda.BeforeLoadDFMValues;
  Promocoes_ItensDatasetprodnome.BeforeLoadDFMValues;
  Promocoes_ItensDatasetprodcodigo_barras.BeforeLoadDFMValues;
  Promocoes_ItensDatasetprodcodigo_interno.BeforeLoadDFMValues;
  Promocoes_ItensDatasetprodassociacaofsprodimagem.BeforeLoadDFMValues;
  Promocoes_ItensDatasetprodassociacaostatus.BeforeLoadDFMValues;
  Promocoes_ItensDatasetproddbassociar_produtos.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewPromocoesEdit';
    Width := 914;
    Height := 393;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCloseQuery', 'WebFormCloseQuery');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 16;
    lbid.Top := 24;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbaliado_nome.SetParentComponent(Self);
    lbaliado_nome.Name := 'lbaliado_nome';
    lbaliado_nome.Left := 16;
    lbaliado_nome.Top := 51;
    lbaliado_nome.Width := 33;
    lbaliado_nome.Height := 13;
    lbaliado_nome.Caption := 'Aliado:';
    lbaliado_nome.HeightPercent := 100.000000000000000000;
    lbaliado_nome.WidthPercent := 100.000000000000000000;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 16;
    lbdata_base_id.Top := 78;
    lbdata_base_id.Width := 59;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'C'#243'd. Banco:';
    lbdata_base_id.HeightPercent := 100.000000000000000000;
    lbdata_base_id.WidthPercent := 100.000000000000000000;
    lbfuncionario_nome.SetParentComponent(Self);
    lbfuncionario_nome.Name := 'lbfuncionario_nome';
    lbfuncionario_nome.Left := 16;
    lbfuncionario_nome.Top := 105;
    lbfuncionario_nome.Width := 59;
    lbfuncionario_nome.Height := 13;
    lbfuncionario_nome.Caption := 'Funcion'#225'rio:';
    lbfuncionario_nome.HeightPercent := 100.000000000000000000;
    lbfuncionario_nome.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 16;
    lbnome.Top := 132;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbdata_inicio.SetParentComponent(Self);
    lbdata_inicio.Name := 'lbdata_inicio';
    lbdata_inicio.Left := 16;
    lbdata_inicio.Top := 159;
    lbdata_inicio.Width := 55;
    lbdata_inicio.Height := 13;
    lbdata_inicio.Caption := 'Data In'#237'cio:';
    lbdata_inicio.HeightPercent := 100.000000000000000000;
    lbdata_inicio.WidthPercent := 100.000000000000000000;
    lbdata_fim.SetParentComponent(Self);
    lbdata_fim.Name := 'lbdata_fim';
    lbdata_fim.Left := 16;
    lbdata_fim.Top := 186;
    lbdata_fim.Width := 46;
    lbdata_fim.Height := 13;
    lbdata_fim.Caption := 'Data Fim:';
    lbdata_fim.HeightPercent := 100.000000000000000000;
    lbdata_fim.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 232;
    lbstatus.Top := 24;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 232;
    lbcodigo_interno.Top := 51;
    lbcodigo_interno.Width := 66;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Interno:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 232;
    lbexcluido.Top := 78;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 232;
    lbinclusao.Top := 105;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 232;
    lbalteracao.Top := 132;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 232;
    lbexclusao.Top := 159;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 448;
    lbPaginationInfo.Top := 256;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 301;
    btCancel.Top := 244;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 85;
    edid.Top := 21;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edaliado_nome.SetParentComponent(Self);
    edaliado_nome.Name := 'edaliado_nome';
    edaliado_nome.Left := 85;
    edaliado_nome.Top := 48;
    edaliado_nome.Width := 120;
    edaliado_nome.Height := 21;
    edaliado_nome.Enabled := False;
    edaliado_nome.HeightPercent := 100.000000000000000000;
    edaliado_nome.TabOrder := 7;
    edaliado_nome.Text := 'edaliado_nome';
    edaliado_nome.WidthPercent := 100.000000000000000000;
    edaliado_nome.DataField := 'aliado.Nome_Fantasia';
    edaliado_nome.DataSource := DataSource;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 85;
    eddata_base_id.Top := 75;
    eddata_base_id.Width := 120;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := False;
    eddata_base_id.HeightPercent := 100.000000000000000000;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.WidthPercent := 100.000000000000000000;
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    edfuncionario_nome.SetParentComponent(Self);
    edfuncionario_nome.Name := 'edfuncionario_nome';
    edfuncionario_nome.Left := 85;
    edfuncionario_nome.Top := 102;
    edfuncionario_nome.Width := 120;
    edfuncionario_nome.Height := 21;
    edfuncionario_nome.Enabled := False;
    edfuncionario_nome.HeightPercent := 100.000000000000000000;
    edfuncionario_nome.TabOrder := 9;
    edfuncionario_nome.Text := 'edfuncionario_nome';
    edfuncionario_nome.WidthPercent := 100.000000000000000000;
    edfuncionario_nome.DataField := 'funcionario.nome';
    edfuncionario_nome.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 85;
    ednome.Top := 129;
    ednome.Width := 120;
    ednome.Height := 21;
    ednome.Enabled := False;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 10;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    eddata_inicio.SetParentComponent(Self);
    eddata_inicio.Name := 'eddata_inicio';
    eddata_inicio.Left := 85;
    eddata_inicio.Top := 156;
    eddata_inicio.Width := 120;
    eddata_inicio.Height := 21;
    eddata_inicio.Enabled := False;
    eddata_inicio.HeightPercent := 100.000000000000000000;
    eddata_inicio.TabOrder := 11;
    eddata_inicio.Text := 'eddata_inicio';
    eddata_inicio.WidthPercent := 100.000000000000000000;
    eddata_inicio.DataField := 'data_inicio';
    eddata_inicio.DataSource := DataSource;
    eddata_fim.SetParentComponent(Self);
    eddata_fim.Name := 'eddata_fim';
    eddata_fim.Left := 85;
    eddata_fim.Top := 183;
    eddata_fim.Width := 120;
    eddata_fim.Height := 21;
    eddata_fim.Enabled := False;
    eddata_fim.HeightPercent := 100.000000000000000000;
    eddata_fim.TabOrder := 12;
    eddata_fim.Text := 'eddata_fim';
    eddata_fim.WidthPercent := 100.000000000000000000;
    eddata_fim.DataField := 'data_fim';
    eddata_fim.DataSource := DataSource;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 301;
    edstatus.Top := 21;
    edstatus.Width := 120;
    edstatus.Height := 21;
    edstatus.Enabled := False;
    edstatus.HeightPercent := 100.000000000000000000;
    edstatus.TabOrder := 13;
    edstatus.Text := 'edstatus';
    edstatus.WidthPercent := 100.000000000000000000;
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 301;
    edcodigo_interno.Top := 48;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 14;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 301;
    edinclusao.Top := 102;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 16;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 301;
    edalteracao.Top := 129;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 17;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 301;
    edexclusao.Top := 156;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 18;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbbexcluido.SetParentComponent(Self);
    cbbexcluido.Name := 'cbbexcluido';
    cbbexcluido.Left := 301;
    cbbexcluido.Top := 75;
    cbbexcluido.Width := 120;
    cbbexcluido.Height := 22;
    cbbexcluido.Caption := 'cbbexcluido';
    cbbexcluido.ChildOrder := 33;
    cbbexcluido.Enabled := False;
    cbbexcluido.HeightPercent := 100.000000000000000000;
    cbbexcluido.WidthPercent := 100.000000000000000000;
    cbbexcluido.DataField := 'excluido';
    cbbexcluido.DataSource := DataSource;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 448;
    WebDBTableControl1.Top := 51;
    WebDBTableControl1.Width := 461;
    WebDBTableControl1.Height := 182;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ChildOrder := 28;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Selecionar';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'prod.codigo_interno';
      Title := 'C'#243'd. Produto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Imagem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'prod.codigo_barras';
      Title := 'C'#243'd. Barras';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'prod.nome';
      Title := 'Produto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'prod.preco_venda';
      Title := 'Pre'#231'o Venda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'preco_promocional';
      Title := 'Pre'#231'o Promocional';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'prod.associacao.status';
      Title := 'Status Associa'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 448;
    cbPageSize.Top := 24;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 788;
    edSearch.Top := 23;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.ChildOrder := 30;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 728;
    lcPaginator.Top := 244;
    lcPaginator.Width := 173;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 31;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    pnlDadosPromocao.SetParentComponent(Self);
    pnlDadosPromocao.Name := 'pnlDadosPromocao';
    pnlDadosPromocao.Left := 8;
    pnlDadosPromocao.Top := 0;
    pnlDadosPromocao.Width := 413;
    pnlDadosPromocao.Height := 17;
    pnlDadosPromocao.Caption := 'Espa'#231'o form dados';
    pnlDadosPromocao.ChildOrder := 23;
    pnlDadosPromocao.Color := clInfoText;
    pnlDadosPromocao.Font.Charset := DEFAULT_CHARSET;
    pnlDadosPromocao.Font.Color := clWhite;
    pnlDadosPromocao.Font.Height := -11;
    pnlDadosPromocao.Font.Name := 'Tahoma';
    pnlDadosPromocao.Font.Style := [fsBold];
    pnlDadosPromocao.ParentFont := False;
    pnlDadosPromocao.TabOrder := 18;
    pnlDadosPromocao.Visible := False;
    pnlItensPromocao.SetParentComponent(Self);
    pnlItensPromocao.Name := 'pnlItensPromocao';
    pnlItensPromocao.Left := 448;
    pnlItensPromocao.Top := 0;
    pnlItensPromocao.Width := 461;
    pnlItensPromocao.Height := 17;
    pnlItensPromocao.Caption := 'Espa'#231'o tabela Itens';
    pnlItensPromocao.ChildOrder := 23;
    pnlItensPromocao.Color := clInfoText;
    pnlItensPromocao.Font.Charset := DEFAULT_CHARSET;
    pnlItensPromocao.Font.Color := clWhite;
    pnlItensPromocao.Font.Height := -11;
    pnlItensPromocao.Font.Name := 'Tahoma';
    pnlItensPromocao.Font.Style := [fsBold];
    pnlItensPromocao.ParentFont := False;
    pnlItensPromocao.TabOrder := 19;
    pnlItensPromocao.Visible := False;
    btnItensTab.SetParentComponent(Self);
    btnItensTab.Name := 'btnItensTab';
    btnItensTab.Left := 624;
    btnItensTab.Top := 23;
    btnItensTab.Width := 96;
    btnItensTab.Height := 25;
    btnItensTab.Caption := 'Itens';
    btnItensTab.ChildOrder := 34;
    btnItensTab.HeightPercent := 100.000000000000000000;
    btnItensTab.TabOrder := 1;
    btnItensTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnItensTab, Self, 'OnClick', 'btnItensTabClick');
    btnMarcarDesmarcarTodos.SetParentComponent(Self);
    btnMarcarDesmarcarTodos.Name := 'btnMarcarDesmarcarTodos';
    btnMarcarDesmarcarTodos.Left := 448;
    btnMarcarDesmarcarTodos.Top := 275;
    btnMarcarDesmarcarTodos.Width := 96;
    btnMarcarDesmarcarTodos.Height := 25;
    btnMarcarDesmarcarTodos.Caption := 'Marcar Todos';
    btnMarcarDesmarcarTodos.ChildOrder := 36;
    btnMarcarDesmarcarTodos.HeightPercent := 100.000000000000000000;
    btnMarcarDesmarcarTodos.WidthPercent := 100.000000000000000000;
    SetEvent(btnMarcarDesmarcarTodos, Self, 'OnClick', 'btnMarcarDesmarcarTodosClick');
    btnGerenciarAssociacao.SetParentComponent(Self);
    btnGerenciarAssociacao.Name := 'btnGerenciarAssociacao';
    btnGerenciarAssociacao.Left := 448;
    btnGerenciarAssociacao.Top := 306;
    btnGerenciarAssociacao.Width := 96;
    btnGerenciarAssociacao.Height := 25;
    btnGerenciarAssociacao.Caption := 'Associar (0) produto(s)';
    btnGerenciarAssociacao.ChildOrder := 36;
    btnGerenciarAssociacao.HeightPercent := 100.000000000000000000;
    btnGerenciarAssociacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnGerenciarAssociacao, Self, 'OnClick', 'btnGerenciarAssociacaoClick');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := PromocoesDataset;
    DataSource.Left := 240;
    DataSource.Top := 216;
    PromocoesDataset.SetParentComponent(Self);
    PromocoesDataset.Name := 'PromocoesDataset';
    PromocoesDataset.AfterApplyUpdates := PromocoesDatasetAfterApplyUpdates;
    PromocoesDataset.EntitySetName := 'Promocoes';
    PromocoesDataset.Connection := DMConnection.ApiConnection;
    PromocoesDataset.Left := 32;
    PromocoesDataset.Top := 224;
    PromocoesDatasetid.SetParentComponent(PromocoesDataset);
    PromocoesDatasetid.Name := 'PromocoesDatasetid';
    PromocoesDatasetid.FieldName := 'id';
    PromocoesDatasetid.Required := True;
    PromocoesDatasetaliado_id.SetParentComponent(PromocoesDataset);
    PromocoesDatasetaliado_id.Name := 'PromocoesDatasetaliado_id';
    PromocoesDatasetaliado_id.FieldName := 'aliado_id';
    PromocoesDatasetaliado_id.Required := True;
    PromocoesDatasetdata_base_id.SetParentComponent(PromocoesDataset);
    PromocoesDatasetdata_base_id.Name := 'PromocoesDatasetdata_base_id';
    PromocoesDatasetdata_base_id.FieldName := 'data_base_id';
    PromocoesDatasetdata_base_id.Required := True;
    PromocoesDatasetfuncionario_id.SetParentComponent(PromocoesDataset);
    PromocoesDatasetfuncionario_id.Name := 'PromocoesDatasetfuncionario_id';
    PromocoesDatasetfuncionario_id.FieldName := 'funcionario_id';
    PromocoesDatasetnome.SetParentComponent(PromocoesDataset);
    PromocoesDatasetnome.Name := 'PromocoesDatasetnome';
    PromocoesDatasetnome.FieldName := 'nome';
    PromocoesDatasetnome.Size := 255;
    PromocoesDatasetdata_inicio.SetParentComponent(PromocoesDataset);
    PromocoesDatasetdata_inicio.Name := 'PromocoesDatasetdata_inicio';
    PromocoesDatasetdata_inicio.FieldName := 'data_inicio';
    PromocoesDatasetdata_inicio.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetdata_fim.SetParentComponent(PromocoesDataset);
    PromocoesDatasetdata_fim.Name := 'PromocoesDatasetdata_fim';
    PromocoesDatasetdata_fim.FieldName := 'data_fim';
    PromocoesDatasetdata_fim.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetstatus.SetParentComponent(PromocoesDataset);
    PromocoesDatasetstatus.Name := 'PromocoesDatasetstatus';
    PromocoesDatasetstatus.FieldName := 'status';
    SetEvent(PromocoesDatasetstatus, Self, 'OnGetText', 'PromocoesDatasetstatusGetText');
    PromocoesDatasetcodigo_interno.SetParentComponent(PromocoesDataset);
    PromocoesDatasetcodigo_interno.Name := 'PromocoesDatasetcodigo_interno';
    PromocoesDatasetcodigo_interno.FieldName := 'codigo_interno';
    PromocoesDatasetcodigo_interno.Required := True;
    PromocoesDatasetexcluido.SetParentComponent(PromocoesDataset);
    PromocoesDatasetexcluido.Name := 'PromocoesDatasetexcluido';
    PromocoesDatasetexcluido.FieldName := 'excluido';
    PromocoesDatasetinclusao.SetParentComponent(PromocoesDataset);
    PromocoesDatasetinclusao.Name := 'PromocoesDatasetinclusao';
    PromocoesDatasetinclusao.FieldName := 'inclusao';
    PromocoesDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetalteracao.SetParentComponent(PromocoesDataset);
    PromocoesDatasetalteracao.Name := 'PromocoesDatasetalteracao';
    PromocoesDatasetalteracao.FieldName := 'alteracao';
    PromocoesDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetexclusao.SetParentComponent(PromocoesDataset);
    PromocoesDatasetexclusao.Name := 'PromocoesDatasetexclusao';
    PromocoesDatasetexclusao.FieldName := 'exclusao';
    PromocoesDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetaliadoNome_Fantasia.SetParentComponent(PromocoesDataset);
    PromocoesDatasetaliadoNome_Fantasia.Name := 'PromocoesDatasetaliadoNome_Fantasia';
    PromocoesDatasetaliadoNome_Fantasia.FieldKind := fkCalculated;
    PromocoesDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    PromocoesDatasetaliadoNome_Fantasia.Calculated := True;
    PromocoesDatasetfuncionarionome.SetParentComponent(PromocoesDataset);
    PromocoesDatasetfuncionarionome.Name := 'PromocoesDatasetfuncionarionome';
    PromocoesDatasetfuncionarionome.FieldKind := fkCalculated;
    PromocoesDatasetfuncionarionome.FieldName := 'funcionario.nome';
    PromocoesDatasetfuncionarionome.Calculated := True;
    XDataClientPromocoesGet.SetParentComponent(Self);
    XDataClientPromocoesGet.Name := 'XDataClientPromocoesGet';
    XDataClientPromocoesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPromocoesGet, Self, 'OnLoad', 'XDataClientPromocoesGetLoad');
    XDataClientPromocoesGet.Left := 128;
    XDataClientPromocoesGet.Top := 224;
    Promocoes_ItensDataset.SetParentComponent(Self);
    Promocoes_ItensDataset.Name := 'Promocoes_ItensDataset';
    Promocoes_ItensDataset.AfterOpen := Promocoes_ItensDatasetAfterOpen;
    Promocoes_ItensDataset.EntitySetName := 'Promocoes_Itens';
    Promocoes_ItensDataset.Connection := DMConnection.ApiConnection;
    Promocoes_ItensDataset.Left := 664;
    Promocoes_ItensDataset.Top := 173;
    Promocoes_ItensDatasetid.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetid.Name := 'Promocoes_ItensDatasetid';
    Promocoes_ItensDatasetid.FieldName := 'id';
    Promocoes_ItensDatasetid.Required := True;
    Promocoes_ItensDatasetproduto_id.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetproduto_id.Name := 'Promocoes_ItensDatasetproduto_id';
    Promocoes_ItensDatasetproduto_id.FieldName := 'produto_id';
    Promocoes_ItensDatasetproduto_id.DisplayFormat := '#,##0';
    Promocoes_ItensDatasetpreco_promocional.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetpreco_promocional.Name := 'Promocoes_ItensDatasetpreco_promocional';
    Promocoes_ItensDatasetpreco_promocional.FieldName := 'preco_promocional';
    Promocoes_ItensDatasetpreco_promocional.DisplayFormat := 'R$ #,##0.00';
    Promocoes_ItensDatasetexcluido.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetexcluido.Name := 'Promocoes_ItensDatasetexcluido';
    Promocoes_ItensDatasetexcluido.FieldName := 'excluido';
    Promocoes_ItensDatasetinclusao.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetinclusao.Name := 'Promocoes_ItensDatasetinclusao';
    Promocoes_ItensDatasetinclusao.FieldName := 'inclusao';
    Promocoes_ItensDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Promocoes_ItensDatasetalteracao.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetalteracao.Name := 'Promocoes_ItensDatasetalteracao';
    Promocoes_ItensDatasetalteracao.FieldName := 'alteracao';
    Promocoes_ItensDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Promocoes_ItensDatasetexclusao.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetexclusao.Name := 'Promocoes_ItensDatasetexclusao';
    Promocoes_ItensDatasetexclusao.FieldName := 'exclusao';
    Promocoes_ItensDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Promocoes_ItensDatasetprodpreco_venda.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetprodpreco_venda.Name := 'Promocoes_ItensDatasetprodpreco_venda';
    Promocoes_ItensDatasetprodpreco_venda.FieldKind := fkCalculated;
    Promocoes_ItensDatasetprodpreco_venda.FieldName := 'prod.preco_venda';
    Promocoes_ItensDatasetprodpreco_venda.DisplayFormat := 'R$ #,##0.00';
    Promocoes_ItensDatasetprodpreco_venda.Calculated := True;
    Promocoes_ItensDatasetprodnome.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetprodnome.Name := 'Promocoes_ItensDatasetprodnome';
    Promocoes_ItensDatasetprodnome.FieldKind := fkCalculated;
    Promocoes_ItensDatasetprodnome.FieldName := 'prod.nome';
    Promocoes_ItensDatasetprodnome.Calculated := True;
    Promocoes_ItensDatasetprodcodigo_barras.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetprodcodigo_barras.Name := 'Promocoes_ItensDatasetprodcodigo_barras';
    Promocoes_ItensDatasetprodcodigo_barras.FieldKind := fkCalculated;
    Promocoes_ItensDatasetprodcodigo_barras.FieldName := 'prod.codigo_barras';
    Promocoes_ItensDatasetprodcodigo_barras.Calculated := True;
    Promocoes_ItensDatasetprodcodigo_interno.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetprodcodigo_interno.Name := 'Promocoes_ItensDatasetprodcodigo_interno';
    Promocoes_ItensDatasetprodcodigo_interno.FieldKind := fkCalculated;
    Promocoes_ItensDatasetprodcodigo_interno.FieldName := 'prod.codigo_interno';
    Promocoes_ItensDatasetprodcodigo_interno.Calculated := True;
    Promocoes_ItensDatasetprodassociacaofsprodimagem.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetprodassociacaofsprodimagem.Name := 'Promocoes_ItensDatasetprodassociacaofsprodimagem';
    Promocoes_ItensDatasetprodassociacaofsprodimagem.Tag := 1;
    Promocoes_ItensDatasetprodassociacaofsprodimagem.FieldName := 'prod.associacao.fsprod.imagem';
    Promocoes_ItensDatasetprodassociacaostatus.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetprodassociacaostatus.Name := 'Promocoes_ItensDatasetprodassociacaostatus';
    Promocoes_ItensDatasetprodassociacaostatus.FieldName := 'prod.associacao.status';
    Promocoes_ItensDatasetproddbassociar_produtos.SetParentComponent(Promocoes_ItensDataset);
    Promocoes_ItensDatasetproddbassociar_produtos.Name := 'Promocoes_ItensDatasetproddbassociar_produtos';
    Promocoes_ItensDatasetproddbassociar_produtos.Tag := 1;
    Promocoes_ItensDatasetproddbassociar_produtos.FieldName := 'prod.db.associar_produtos';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Promocoes_ItensDataset;
    WebDataSource.Left := 584;
    WebDataSource.Top := 141;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 744;
    tmrConsulta.Top := 144;
  finally
    lbid.AfterLoadDFMValues;
    lbaliado_nome.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    lbfuncionario_nome.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbdata_inicio.AfterLoadDFMValues;
    lbdata_fim.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbPaginationInfo.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edaliado_nome.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    edfuncionario_nome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    eddata_inicio.AfterLoadDFMValues;
    eddata_fim.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbbexcluido.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    pnlDadosPromocao.AfterLoadDFMValues;
    pnlItensPromocao.AfterLoadDFMValues;
    btnItensTab.AfterLoadDFMValues;
    btnMarcarDesmarcarTodos.AfterLoadDFMValues;
    btnGerenciarAssociacao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    PromocoesDataset.AfterLoadDFMValues;
    PromocoesDatasetid.AfterLoadDFMValues;
    PromocoesDatasetaliado_id.AfterLoadDFMValues;
    PromocoesDatasetdata_base_id.AfterLoadDFMValues;
    PromocoesDatasetfuncionario_id.AfterLoadDFMValues;
    PromocoesDatasetnome.AfterLoadDFMValues;
    PromocoesDatasetdata_inicio.AfterLoadDFMValues;
    PromocoesDatasetdata_fim.AfterLoadDFMValues;
    PromocoesDatasetstatus.AfterLoadDFMValues;
    PromocoesDatasetcodigo_interno.AfterLoadDFMValues;
    PromocoesDatasetexcluido.AfterLoadDFMValues;
    PromocoesDatasetinclusao.AfterLoadDFMValues;
    PromocoesDatasetalteracao.AfterLoadDFMValues;
    PromocoesDatasetexclusao.AfterLoadDFMValues;
    PromocoesDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    PromocoesDatasetfuncionarionome.AfterLoadDFMValues;
    XDataClientPromocoesGet.AfterLoadDFMValues;
    Promocoes_ItensDataset.AfterLoadDFMValues;
    Promocoes_ItensDatasetid.AfterLoadDFMValues;
    Promocoes_ItensDatasetproduto_id.AfterLoadDFMValues;
    Promocoes_ItensDatasetpreco_promocional.AfterLoadDFMValues;
    Promocoes_ItensDatasetexcluido.AfterLoadDFMValues;
    Promocoes_ItensDatasetinclusao.AfterLoadDFMValues;
    Promocoes_ItensDatasetalteracao.AfterLoadDFMValues;
    Promocoes_ItensDatasetexclusao.AfterLoadDFMValues;
    Promocoes_ItensDatasetprodpreco_venda.AfterLoadDFMValues;
    Promocoes_ItensDatasetprodnome.AfterLoadDFMValues;
    Promocoes_ItensDatasetprodcodigo_barras.AfterLoadDFMValues;
    Promocoes_ItensDatasetprodcodigo_interno.AfterLoadDFMValues;
    Promocoes_ItensDatasetprodassociacaofsprodimagem.AfterLoadDFMValues;
    Promocoes_ItensDatasetprodassociacaostatus.AfterLoadDFMValues;
    Promocoes_ItensDatasetproddbassociar_produtos.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
